import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { App } from "./App";
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<App data-id="element-5" />} data-id="element-4" />
          </Routes>
      </BrowserRouter>;
}